<template>
  <div class="quote-sel">
    <button type="button" class="q-trigger" @click="open = !open">
      <img v-if="iconOf(current)" class="q-icon" :src="iconOf(current)" :alt="current.nativeSymbol" />
      <span v-else class="q-icon q-icon-text" :style="iconStyle(current)">{{ initialOf(current) }}</span>
      <span>{{ current.label }}</span>
      <svg class="caret" :class="{ open }" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6" /></svg>
    </button>

    <template v-if="open">
      <div class="q-backdrop" @click="open = false"></div>
      <ul class="q-menu">
        <li v-for="p in pairs" :key="p.key" :class="{ active: p.key === currentKey }" @click="choose(p)">
          <img v-if="iconOf(p)" class="q-icon" :src="iconOf(p)" :alt="p.nativeSymbol" />
          <span v-else class="q-icon q-icon-text" :style="iconStyle(p)">{{ initialOf(p) }}</span>
          <span>{{ p.label }}</span>
          <svg v-if="p.key === currentKey" class="check" viewBox="0 0 24 24"><path d="M5 12l4 4 10-10" /></svg>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { getPairs } from "../quote";

// 只有 ETH 有现成图标，其它链用色块+首字母顶上，避免为每条链找素材
const CHAIN_ICON = { ETH: "/recovered-assets/eth_logo.png" };
const CHAIN_COLOR = { BNB: "#f3ba2f", ETH: "#627eea" };

export default {
  name: "QuoteSelect",
  data() {
    return { open: false };
  },
  computed: {
    pairs() {
      return getPairs();
    },
    currentKey() {
      return `${this.$chainCode}:${this.$quote}`;
    },
    current() {
      const hit = this.pairs.find((p) => p.key === this.currentKey);
      if (hit) return hit;
      return (
        this.pairs[0] || {
          key: "",
          nativeSymbol: this.$chainSymbol,
          coin: this.$quote,
          label: `${this.$chainSymbol}/${this.$quote}`,
        }
      );
    },
  },
  methods: {
    iconOf(pair) {
      return CHAIN_ICON[(pair && pair.nativeSymbol) || ""] || "";
    },
    initialOf(pair) {
      return String((pair && pair.nativeSymbol) || "?").charAt(0);
    },
    iconStyle(pair) {
      return { background: CHAIN_COLOR[(pair && pair.nativeSymbol) || ""] || "#5a6478" };
    },
    choose(pair) {
      this.$setPair(pair.chainCode, pair.coin);
      this.open = false;
    },
  },
};
</script>

<style scoped>
.quote-sel {
  position: relative;
}

.q-trigger {
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--pool-text);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.q-icon {
  width: 20px;
  height: 20px;
  flex: none;
  border-radius: 50%;
}

/* 没有图标素材的链：色块 + 首字母 */
.q-icon-text {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #14203a;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
}

.caret {
  width: 13px;
  height: 13px;
  stroke: var(--pool-muted);
  fill: none;
  stroke-width: 2.4;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: transform 0.15s;
}

.caret.open {
  transform: rotate(180deg);
}

.q-backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
}

.q-menu {
  position: absolute;
  top: 150%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 41;
  margin: 0;
  padding: 6px;
  list-style: none;
  min-width: 180px;
  background: rgba(12, 17, 34, 0.86);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid var(--pool-line);
  border-radius: 14px;
  box-shadow: 0 18px 40px -14px rgba(0, 0, 0, 0.7);
}

.q-menu li {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 12px;
  border-radius: 10px;
  color: var(--pool-text);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}


.q-menu li:hover {
  background: var(--pool-glass-2);
}

.q-menu li.active {
  color: var(--pool-gold);
}

.q-menu li .check {
  margin-left: auto;
  width: 16px;
  height: 16px;
  stroke: var(--pool-gold);
  fill: none;
  stroke-width: 2.4;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
